import React, {Component} from 'react';
import Loadable from 'react-loadable';
import {Switch, Route, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {loadLanguage, switchLanguage} from '../redux/localeReducer';
import {removeSession, switchRole, loadSession, loadSessionLive} from '../../modules/auth/actions/session';
import {CodeLoading, Header, TopNavHeader, Sidebar, Footer, PermissionRoute} from '../components';
import socket from '../../helpers/socket';
import {isTeamMember, isLocationCustomer, isStationManager, isStationOperator} from '../../helpers/utils';
import common from '../locales/common.json';
import Dashboard from '../../modules/dashboard/containers/Dashboard';
import Dashboard2 from '../../modules/dashboard/containers/Dashboard2';
import Dashboard3 from '../../modules/dashboard/containers/Dashboard3';
import Dashboard4 from '../../modules/dashboard/containers/Dashboard4';
import Dashboard5 from '../../modules/dashboard/containers/Dashboard5';
import Dashboard6 from '../../modules/dashboard/containers/Dashboard6';
import Dashboard7 from '../../modules/dashboard/containers/Dashboard7';
import Dashboard8 from '../../modules/dashboard/containers/Dashboard8';

import StationOperatorAlert from '../../modules/alert/containers/StationOperatorAlert';
import StationManagerAlert from '../../modules/alert/containers/StationManagerAlert';

const Profile = Loadable({loading: CodeLoading, loader: () => import("../../modules/profile/containers/Profile")});
const Role = Loadable({loading: CodeLoading, loader: () => import("../../modules/role/containers/Role")});
const Region = Loadable({loading: CodeLoading, loader: () => import("../../modules/region/containers/Region")});
const BusinessUnit = Loadable({loading: CodeLoading, loader: () => import("../../modules/businessUnit/containers/BusinessUnit")});
const Station = Loadable({loading: CodeLoading, loader: () => import("../../modules/station/containers/Station")});

const Andon = Loadable({loading: CodeLoading, loader: () => import("../../modules/andon/containers/Andon")});

const User = Loadable({loading: CodeLoading, loader: () => import("../../modules/user/containers/User")});

const ViewWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/ViewWorkOrder")});
const CreateWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/CreateWorkOrder")});
const UpdateWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/UpdateWorkOrder")});
const ApproveWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/ApproveWorkOrder")});
const FinalizeWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/FinalizeWorkOrder")});
const SearchWorkOrder = Loadable({loading: CodeLoading, loader: () => import("../../modules/workOrder/containers/SearchWorkOrder")});

const Inspection = Loadable({loading: CodeLoading, loader: () => import("../../modules/inspection/containers/Inspection")});

const PaidHour = Loadable({loading: CodeLoading, loader: () => import("../../modules/paidHour/containers/PaidHour")});
const BillHour = Loadable({loading: CodeLoading, loader: () => import("../../modules/billHour/containers/BillHour")});
const WorkBillHour = Loadable({loading: CodeLoading, loader: () => import("../../modules/workBillHour/containers/WorkBillHour")});

const Report = Loadable({loading: CodeLoading, loader: () => import("../../modules/report/containers/Report")});
const Customer = Loadable({loading: CodeLoading, loader: () => import("../../modules/customer/containers/Customer")});
const Audit = Loadable({loading: CodeLoading, loader: () => import("../../modules/audit/containers/Audit")});
const WorkInstruction = Loadable({loading: CodeLoading, loader: () => import("../../modules/workInstruction/containers/WorkInstruction")});
const TrainingDocs = Loadable({loading: CodeLoading, loader: () => import("../../modules/trainingDocs/containers/TrainingDocs")});
const ShiftNote = Loadable({loading: CodeLoading, loader: () => import("../../modules/shiftNote/containers/ShiftNote")});
const AlertLibrary = Loadable({loading: CodeLoading, loader: () => import("../../modules/alertLibrary/containers/AlertLibrary")});
const PartLibrary = Loadable({loading: CodeLoading, loader: () => import("../../modules/partLibrary/containers/PartLibrary")});
const Bin = Loadable({loading: CodeLoading, loader: () => import("../../modules/bin/containers/Bin")});
const BinPartVerification = Loadable({loading: CodeLoading, loader: () => import("../../modules/bin/containers/BinPartVerification")});
const Sms = Loadable({loading: CodeLoading, loader: () => import("../../modules/sms/containers/Sms")});
const Invoice = Loadable({loading: CodeLoading, loader: () => import("../../modules/invoice/containers/Invoice")});

const Plex = Loadable({loading: CodeLoading, loader: () => import("../../modules/plex/containers/Plex")});
const Vertex = Loadable({loading: CodeLoading, loader: () => import("../../modules/vertex/containers/Vertex")});
const Vin = Loadable({loading: CodeLoading, loader: () => import("../../modules/vin/containers/Vin")});
const Question = Loadable({loading: CodeLoading, loader: () => import("../../modules/question/containers/Question")});

const TimeClock = Loadable({loading: CodeLoading, loader: () => import("../../modules/timeClock/containers/TimeClock")});

class FullWidth extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage, loadSessionLive, session} = this.props;
		loadLanguage(common);

		document.body.classList.add('skin-custom');
		if(isStationManager(session) || isStationOperator(session)) {
			document.body.classList.add('layout-top-nav');
		} else {
			document.body.classList.add('sidebar-mini');
			if(window.innerWidth > 767) {
				document.body.classList.add('sidebar-collapse');
			}
		}

		socket().on('user.session.update', (data) => {
			loadSessionLive();
		});

		socket().on('role.permission.update', (data) => {
			loadSessionLive();
		});
	}

	componentDidMount() {
		const {session} = this.props;

		if( !(isStationManager(session) || isStationOperator(session)) ) {
			ViewWorkOrder.preload();
			CreateWorkOrder.preload();
			UpdateWorkOrder.preload();
			ApproveWorkOrder.preload();
			FinalizeWorkOrder.preload();
			SearchWorkOrder.preload();

			Inspection.preload();

			PaidHour.preload();
			BillHour.preload();
			WorkBillHour.preload();
			Report.preload();
			Customer.preload();

			Station.preload();
			BusinessUnit.preload();
			Region.preload();

			Andon.preload();
			AlertLibrary.preload();
			User.preload();

			Audit.preload();
			WorkInstruction.preload();
			TrainingDocs.preload();
			ShiftNote.preload();

			PartLibrary.preload();
			Bin.preload();
			BinPartVerification.preload();
			Sms.preload();

			Plex.preload();
			Vertex.preload();

			Profile.preload();
			Role.preload();

			Invoice.preload();
			Vin.preload();
			Question.preload();

			TimeClock.preload();
		}

		if(session) {
			socket().emit('user.join.personal', session.user_id);
			socket().emit('role.join', session.active_role_id);
		}
	}

	componentWillUnmount() {
		const {session} = this.props;

		document.body.classList.remove('skin-custom');
		if(isStationManager(session) || isStationOperator(session)) {
			document.body.classList.remove('layout-top-nav');
		} else {
			document.body.classList.remove('sidebar-mini');
			if(window.innerWidth > 767) {
				document.body.classList.remove('sidebar-collapse');
			}
		}
	}

	render() {
		const {translate, activeLocale, removeSession, session, switchLanguage, switchRole} = this.props;

		let content = '';
		if(isStationOperator(session)) {
			content = (
				<div className="wrapper">
					<TopNavHeader translate={translate} session={session} activeLocale={activeLocale} logoutAction={removeSession} switchLanguageAction={switchLanguage}/>
					<Switch>
						<Redirect exact from="/" to="/station-operator-alerts"/>
						<Route exact path="/station-operator-alerts" component={StationOperatorAlert}/>
						<Route component={StationOperatorAlert} />
					</Switch>
				</div>
			);
		} else if(isStationManager(session)) {
			content = (
				<div className="wrapper">
					<TopNavHeader translate={translate} session={session} activeLocale={activeLocale} logoutAction={removeSession} switchLanguageAction={switchLanguage}/>
					<Switch>
						<Redirect exact from="/" to="/station-manager-alerts"/>
						<Route exact path="/station-manager-alerts" component={StationManagerAlert}/>
						<Route component={StationManagerAlert} />
					</Switch>
				</div>
			);
		} else {
			content = (
				<div className="wrapper">
					<Header translate={translate} session={session} activeLocale={activeLocale} logoutAction={removeSession} switchLanguageAction={switchLanguage}/>
					<Sidebar translate={translate} session={session} switchRoleAction={switchRole}/>

					<Switch>
						<Redirect exact from="/" to="/dashboard"/>
						<Route exact path="/dashboard" component={Dashboard}/>
						{
							(!isTeamMember(session)) &&
							<Route exact path="/dashboard/2" component={Dashboard2}/>
						}
						{
							(isLocationCustomer(session)) &&
							<Route exact path="/dashboard/3" component={Dashboard3}/>
						}
						<Route exact path="/dashboard/4" component={Dashboard4}/>
						<Route exact path="/dashboard/5" component={Dashboard5}/>
						<Route exact path="/dashboard/6" component={Dashboard6}/>
						<Route exact path="/dashboard/7" component={Dashboard7}/>
						<Route exact path="/dashboard/8" component={Dashboard8}/>

						<Route exact path="/profile" component={Profile}/>

						<Route path="/roles" component={Role}/>

						<Route path="/organizations/regions" component={Region}/>
						<Route path="/organizations/business-units" component={BusinessUnit}/>
						<Route path="/organizations/stations" component={Station}/>

						<Route path="/users" component={User}/>

						<Route path="/inspections" component={Inspection}/>

						<PermissionRoute path="/work-orders/create" component={CreateWorkOrder} permission="create_work_order"/>
						<PermissionRoute path="/work-orders/update" component={UpdateWorkOrder} permission="edit_work_order"/>
						<PermissionRoute path="/work-orders/approve" component={ApproveWorkOrder} permission="approve_work_order"/>
						<PermissionRoute path="/work-orders/finalize" component={FinalizeWorkOrder} permission="approve_work_order"/>
						<PermissionRoute path="/work-orders/search" component={SearchWorkOrder} permission="search_work_order"/>
						<PermissionRoute path="/work-orders" component={ViewWorkOrder} permission='view_work_order'/>

						<Route path="/paid-hours" component={PaidHour}/>
						<Route path="/bill-hours" component={BillHour}/>
						<Route path="/work-bill-hours" component={WorkBillHour}/>
						<Route path="/reports" component={Report}/>
						<Route path="/customers" component={Customer}/>

						<Route path="/audits" component={Audit}/>

						<Route path="/work-instructions" component={WorkInstruction}/>
						<Route path="/training-docs" component={TrainingDocs}/>
						<Route path="/shift-notes" component={ShiftNote}/>
						<Route path="/alert-libraries" component={AlertLibrary}/>
						<Route path="/andons" component={Andon}/>
						<Route path="/part-libraries" component={PartLibrary}/>
						<Route path="/bins" component={Bin}/>
						<Route path="/bin-part-verifications" component={BinPartVerification}/>
						<Route path="/sms" component={Sms}/>
						<Route path="/plex" component={Plex}/>
						<Route path="/invoices" component={Invoice}/>

						<Route path="/vertex" component={Vertex}/>
						<Route path="/vins" component={Vin}/>
						<Route path="/questions" component={Question}/>

						<Route path="/time-clocks" component={TimeClock}/>

						<Route component={Dashboard} />
					</Switch>
					<Footer/>
				</div>
			);
		}

		return content;
	}
}

const mapStateToProps = state => ({
	activeLocale: getActiveLanguage(state.locale).code,
	translate: getTranslate(state.locale),
	session: state.session
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	loadSession,
	loadSessionLive,
	removeSession,
	switchLanguage,
	switchRole
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FullWidth);
